import { AttachmentLinkFormDataSchema } from "shared/types/AttachmentLinkFormData"
import { DeepPartialWithNull } from "shared/types/DeepPartial"

import { ClarificationRequestSchema } from "entities/clarification-requests/types/ClarificationRequest"
import { FAVORITES_PROJECT_ID } from "entities/favorites/api/useFavoriteMutations"
import z from "zod"

import {
  MAX_LENGTH_PRODUCT_POSITION_PRICE_GROUP,
  ProductPositionSchema
} from "./ProductPosition"

export const ProductPositionFormSchema = z.object({
  projectID: z.uuid().or(z.literal(FAVORITES_PROJECT_ID)),
  parentID: z.uuid().or(z.literal(FAVORITES_PROJECT_ID)).nullish(),
  displayPosition: z.number(), // Top-level display position
  isSpecialPriceGroup: z.boolean().nullish(),
  clarificationRequest: ClarificationRequestSchema.nullish(),
  productPosition: ProductPositionSchema.extend({
    id: ProductPositionSchema.shape.id.nullish(),
    position: ProductPositionSchema.shape.position.nullish()
  }),
  price: z.number().nullish(),
  priceGroup: z.string().max(MAX_LENGTH_PRODUCT_POSITION_PRICE_GROUP).nullish(),
  attachments: AttachmentLinkFormDataSchema.nullish()
})

export type ProductPositionFormData = z.infer<typeof ProductPositionFormSchema>
export type ProductPositionFormState =
  DeepPartialWithNull<ProductPositionFormData>
